import {
  getSingleChoiceValue,
  getFirstLinkedItemOrDefault,
  PLAYER_PORTALS_MODELS,
  getSingleChoiceName,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getFirstMappedLinkedItemOrDefault,
  getMappedLinkedItems,
  getCtaHrefValue,
} from './utils/component-mapping-helpers';

export const data_grid_table = (data: PLAYER_PORTALS_MODELS.DataGridTable) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    playersTableLabel: elements?.players_table_label?.value,
    managersTableLabel: elements?.managers_table_label?.value,
    columns: getMappedLinkedItems(elements?.columns),
    defaultSortColumn: getFirstMappedLinkedItemOrDefault(
      elements?.default_table_sorting__default_sort_column,
    ),
    defaultSortDirection: getSingleChoiceValue(
      elements?.default_table_sorting__default_sort_direction,
    ),
    defaultRowsPerPage: getSingleChoiceName(elements?.default_rows_per_page),
    callbackUrl: getCtaHrefValue(
      getFirstLinkedItemOrDefault(elements?.callback_url),
    ),
    sidePanel: {
      idCard: getFirstMappedLinkedItemOrDefault(elements?.id_card),
      accreditedMembersTable: getFirstMappedLinkedItemOrDefault(
        elements?.accredited_members_table,
      ),
    },
  };
};

export default data_grid_table;
